<template>
  <div>
    <label class="statr">متن مقاله</label>
    <quill-editor
      @ready="onEditorReady($event)"
      v-model="content"
      :options="editorOption"
      @change="onEditorChange($event)"
    />
  </div>
</template>

<script>
export default {
  name: "editor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      content: ''
    };
  },
  beforMount() {
    this.content = this.value
  },
  methods: {
    onEditorReady(editor) {
      editor.format("direction", "rtl");
      editor.format("align", "right");
    },
    onEditorChange({ editor, html, text }) {
      this.$emit("input", html);
    }
  }
};
</script>
<style lang="less">

</style>


// WEBPACK FOOTER //
// src/components/element/editor/index.vue